import 'symbol-observable'; // eslint-disable-line
import { configureStore } from '@reduxjs/toolkit';
import { CONFIG, APP_NAME, SET_LOCATION, PM_START } from 'constants';
import AppUtils from '@control-front-end/utils/utils';
import configSaga from '@control-front-end/common/sagas/config';
import accountsSaga from '@control-front-end/common/sagas/accounts';
import authSaga from '@control-front-end/common/sagas/auth';
import usersSaga from '@control-front-end/common/sagas/users';
import notifySaga from '@control-front-end/common/sagas/notify';
import formListSaga from '@control-front-end/common/sagas/formList';
import formViewSaga from '@control-front-end/common/sagas/formView';
import formAccountsSaga from '@control-front-end/common/sagas/formAccounts';
import actorsAccountsSaga from '@control-front-end/common/sagas/actorsAccounts';
import accountNamesSaga from '@control-front-end/common/sagas/accountNames';
import accountCurrenciesSaga from '@control-front-end/common/sagas/accountCurrencies';
import searchSaga from '@control-front-end/common/sagas/search';
import uploadFileSaga from '@control-front-end/common/sagas/uploadFile';
import postMessage from '@control-front-end/common/sagas/postMessage';
import scriptContentSaga from '@control-front-end/common/sagas/scriptContent';
import scriptsSaga from '@control-front-end/common/sagas/scripts';
import accessRulesSaga from '../sagas/accessRules';
import suggestionsSaga from '../sagas/suggestions';
import reactionsSaga from '../sagas/reactionsSaga';
import wsConnectionSaga from '../sagas/wsConnection.js';
import wsNotifySaga from '../sagas/wsNotify.js';
import expireSessionSaga from '../sagas/expireSession.js';
import checkVersionSaga from '../sagas/checkVersion.js';
import importEventsSaga from '../sagas/importEvents.js';
import actorsFilters from '../sagas/actorsFilters';
import electron from '../sagas/electron';
import graphRealtime from '../sagas/graph/graphRealtime';
import graphEdges from '../sagas/graph/graphEdges';
import graphNodes from '../sagas/graph/graphNodes';
import graphCommon from '../sagas/graph/graphCommon';
import graphFolders from '../sagas/graph/graphFolders';
import systemActors from '../sagas/graph/systemActors';
import actorView from '../sagas/actorView';
import actorsAttaches from '../sagas/actorsAttaches';
import connectors from '../sagas/graph/connectors';
import makeRootReducer, { injectReducer } from '../reducers/index.js';
import sagaMiddleware from '../sagas/runSaga';
import history from './history';

export default () => {
  // ======================================================
  // Инициализация Store
  // ======================================================
  const store = configureStore({
    reducer: makeRootReducer(),
    devTools: __DEV__,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ thunk: false, serializableCheck: false }).concat(
        sagaMiddleware
      ),
  });

  // ======================================================
  //  Запуск sagas, для прослушивания action.
  // ======================================================
  const sagas = [
    authSaga,
    usersSaga,
    notifySaga,
    configSaga,
    accountsSaga,
    searchSaga,
    reactionsSaga,
    wsConnectionSaga,
    wsNotifySaga,
    expireSessionSaga,
    checkVersionSaga,
    importEventsSaga,
    uploadFileSaga,
    scriptsSaga,
    scriptContentSaga,
    formViewSaga,
    formListSaga,
    formAccountsSaga,
    actorsAccountsSaga,
    accountNamesSaga,
    accountCurrenciesSaga,
    suggestionsSaga,
    postMessage,
    graphEdges,
    graphCommon,
    graphNodes,
    graphRealtime,
    graphFolders,
    systemActors,
    actorsAttaches,
    actorView,
    connectors,
    actorsFilters,
    accessRulesSaga,
    electron,
  ];
  for (const sagaItem of sagas) {
    sagaMiddleware.run(sagaItem);
  }
  // ======================================================

  store.asyncReducers = {};
  store.runSaga = sagaMiddleware.run;
  store.injectReducer = injectReducer;

  // ======================================================
  // Запрос получения конфигурации при старте
  // ======================================================
  const { dispatch } = store;
  dispatch({ type: APP_NAME, payload: 'AdminPanel' });
  if (!AppUtils.isPublicScript()) {
    if (AppUtils.isIframe()) {
      dispatch({ type: CONFIG.REQUEST });
      dispatch({ type: PM_START, payload: { appName: 'chromeExt' } });
    } else {
      dispatch({ type: CONFIG.REQUEST });
    }
  }
  // ======================================================
  // Обработка событий из electron
  // ======================================================
  if (window.electron) {
    window.electron.receive('electronActions', (data) => {
      dispatch(data);
    });
  }

  if ('ga' in window) ga('set', 'page', document.location.pathname);
  store.unsubscribeHistory = history.listen((nextLocation) => {
    dispatch({ type: SET_LOCATION, payload: nextLocation.pathname });
    if ('ga' in window) ga('set', 'page', document.location.pathname);
  });

  return store;
};
